import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des traductions
 */
const translationsConfig = {
  entityName: 'translations',
  apiEndpoint: '/api/config/tool/translations',
  exportFileName: 'translations',
  
  translations: {
    title: 'TRANSLATIONS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { key: 'page', label: 'Page', labelKey: 'TABLE_PAGE' },
    { key: 'language_code', label: 'Langue', labelKey: 'TABLE_LANGUAGE' },
    { key: 'translation_key', label: 'Clé', labelKey: 'TABLE_KEY' },
    { 
      key: 'translation_text', 
      label: 'Texte', 
      labelKey: 'TABLE_TEXT',
      className: 'wa-translation-text'
    }
  ],
  
  formFields: [
    {
      name: 'page',
      label: 'Page',
      labelKey: 'TRANSLATION_PAGE',
      type: 'dynamic-select',
      required: true,
      placeholder: 'ex: LOGIN, CONFIG...',
      className: 'wa-form-group',
      dynamicSource: 'page'
    },
    {
      name: 'language_code',
      label: 'Langue',
      labelKey: 'TRANSLATION_LANGUAGE',
      type: 'dynamic-select',
      required: true,
      placeholder: 'ex: FR, EN...',
      className: 'wa-form-group',
      dynamicSource: 'language_code'
    },
    {
      name: 'translation_key',
      label: 'Clé',
      labelKey: 'TRANSLATION_KEY',
      type: 'text',
      required: true,
      placeholder: 'Clé de traduction',
      className: 'wa-form-group'
    },
    {
      name: 'translation_text',
      label: 'Texte',
      labelKey: 'TRANSLATION_TEXT',
      type: 'textarea',
      required: true,
      placeholder: 'Texte de la traduction',
      rows: 3,
      className: 'wa-form-group'
    }
  ],
  
  filters: [
    {
      name: 'language',
      label: 'Langue',
      labelKey: 'FILTER_LANGUAGE',
      type: 'text',
      placeholder: 'ex: FR, EN...'
    },
    {
      name: 'page',
      label: 'Page',
      labelKey: 'FILTER_PAGE',
      type: 'text',
      placeholder: 'ex: LOGIN, CONFIG...'
    },
    {
      name: 'key',
      label: 'Clé',
      labelKey: 'FILTER_KEY',
      type: 'text',
      placeholder: 'Recherche par clé...'
    }
  ],
  
  defaultFormData: {
    page: '',
    language_code: '',
    translation_key: '',
    translation_text: ''
  }
};

/**
 * Composant d'administration des traductions
 */
export default function AdminTranslationsTab() {
  return (
    <AdminDataTable {...translationsConfig} />
  );
}
